module.exports = __webpack_public_path__ + "static/media/report_download.baff4eb6.svg";